'use client';
import { createContext, useContext } from 'react';

type StationPinHelpContext = {
  tenantId: string | null;
  actorId: string | null;
  enabled: boolean;
  stationPinSelfService?: boolean;
  agencyAccess?: boolean;
};
const Context = createContext<StationPinHelpContext>({
  tenantId: null,
  actorId: null,
  enabled: false,
});
export const StationPinHelpProvider = Context.Provider;
export function useStationPinHelpContext(
  tenantId: string | null | undefined,
  actorId: string | null | undefined,
) {
  const value = useContext(Context);
  return (
    value.enabled &&
    !!tenantId &&
    !!actorId &&
    value.tenantId === tenantId &&
    value.actorId === actorId
  );
}

export function useScopedHelpFeatures(
  tenantId: string | null | undefined,
  actorId: string | null | undefined,
) {
  const value = useContext(Context);
  const current =
    !!tenantId && !!actorId && value.tenantId === tenantId && value.actorId === actorId;
  return {
    stationPinSelfService: current && value.stationPinSelfService === true,
    agencyAccess: current && value.agencyAccess === true,
  };
}
